import Request from "@/libs/fetch";

export const artistList = async (params?: any, noLoading?: boolean) =>
  await Request("/artist/search", { type: "get", params, ...(noLoading ? { headers: { noLoading: true } } : {}) });
